import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import RootReducers from './Rootreducers';

import {
  // PreloadedState,
  configureStore,
} from '@reduxjs/toolkit';

import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';

const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: autoMergeLevel2,
};

const persistedReducer = persistReducer<ReturnType<typeof RootReducers>>(
  persistConfig,
  RootReducers
);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  // middleware: (getDefaultMiddleware) =>
  //   getDefaultMiddleware({
  //     serializableCheck: {
  //       // Ignore these action types
  //       ignoredActions: ['your/action/type'],
  //       // Ignore these field paths in all actions
  //       ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
  //       // Ignore these paths in the state
  //       ignoredPaths: ['items.dates'],
  //     },
  //   }),
});

export const persistor = persistStore(store);

// export function configureStoreOld() {
//   // TODO : using the configureStore method of the @reduxjs/toolkit recommended
//   return createStore(
//     persistedReducer,
//     undefined,
//     composeWithDevTools(applyMiddleware(thunk))
//   );
// }

export type RootState = ReturnType<typeof RootReducers>;
